import "./lazyload";
import "./scroll_magic";
import "./scroll";
import "./header";
import "./global_menu";
import "./posts_slider";